<template>
    <div id="defaultPriceBook" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
            <div class="page-name">
                <div class="page-title">
                    <template v-if="!addPriceBookFlag">
                        Price Book List
                    </template>
                    <template v-else-if="addPriceBookFlag && !updatePriceBookFlag">
                        Add Price Book
                    </template>
                    <template v-else-if="addPriceBookFlag && updatePriceBookFlag">
                        Update Price Book
                    </template>
                </div>
                <div class="btn-groups text-right" v-show="!addPriceBookFlag && canAddPriceBook">
                    <button type="submit" id="addUnit" v-on:click.prevent="addNewPriceBook()" class="btn btn-primary">
                        <i class="fp-add"> </i>  Add Price Book
                    </button>
                </div>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content" v-show="addPriceBookFlag">
                    <section class="internal-container price-section-main border-top-table-fl">
                        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="PriceBookForm">
                            <div class='form-row row-cols-md-4 row-cols-1'>
                                <div class="col form-group mt-4">
                                    <div class="custom-checkbox">
                                        <label for="is_miscellaneous" class="checkbox-custom">Is Miscellaneous
                                            <input type="checkbox" v-model="is_miscellaneous" id="is_miscellaneous" name="is_miscellaneous" v-on:click="isMiscellaneous($event)" :disabled="disableFields">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="customer_class">Type</label>
                                    <v-select v-model="priceType" name="customer_class" placeholder="Select Price Book Type."
                                                label="text"
                                                @change="onChangeType"
                                                :options="priceTypeArr" :disabled="disablePriceType">
                                    </v-select>
                                </div>
                              <template v-if="showCustomerField">
                                <div class="col form-group">
                                  <label class="control-label require" for="customer_id">Customer:</label>
                                  <v-select v-model="customer_id" name="customer_id" @input="onSelectCustomer($event)"

                                            label="text" :filterable="false" :options="customerArr"
                                            @search="onSearchCustomer"
                                            placeholder="Select Customer" class="custom-ci-auto-search" :disabled="disableCustomer">
                                    <template slot="no-options">
                                      Search Customer...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                      <div class="d-center">
                                        {{ option.text }}
                                      </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                      <div class="selected d-center">
                                        {{ option.text }}
                                      </div>
                                    </template>
                                  </v-select>
                                  <div class="field-error">{{ customer_error_msg }}</div>
                                </div>
                              </template>
                              <template v-if="showCustomerClassField">
                                <div class="col form-group">
                                    <label class="control-label require" for="customer_class">Customer Class</label>
                                    <v-select v-model="customer_class" name="customer_class" placeholder="Select Customer Class."
                                                label="text"
                                                :options="customerClassArr" :disabled="disableCustomerClass">
                                    </v-select>
                                  <div class="field-error">{{customer_class_error_msg}}</div>
                                </div>
                              </template>
                              <template v-if="showLocationField">
                                <div class="col form-group">
                                    <label class="control-label require" for="location_id">Location</label>
                                    <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                                label="text"
                                                :options="locationArr" :disabled="disableLocation">
                                    </v-select>
                                  <div class="field-error">{{location_error_msg}}</div>
                                </div>
                              </template>
                                <div class="col form-group">
                                    <label class="control-label require" for="customer_class">Effective Date</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" id="effective_date" name="effective_date" :config="optionsDate" v-model="effective_date" data-info="Please select date" ></date-picker>
                                        <label for="effective_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{effective_date_error_msg}}</div>
                                </div>
                              
                                <template v-if="!showChargeField">
                                    <div class="col form-group">
                                        <label class="control-label require" for="cost_type">Cost Type</label>
                                        <v-select v-model="cost_type" name="cost_type" placeholder="Select Cost Type."
                                                    label="text"
                                                    :options="costTypesArr" :disabled="disableFields">
                                        </v-select>
                                        <div class="field-error">{{cost_type_error_msg}}</div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col form-group">
                                        <label class="control-label require" for="charge_id">Charge</label>
                                        <v-select v-model="charge_id" name="charge_id" placeholder="Select Charge."
                                                    label="text"
                                                    :options="chargesArr" @input="onChargeSelect($event)" :disabled="disableFields">
                                        </v-select>
                                        <div class="field-error">{{charge_type_error_msg}}</div>
                                    </div>
                                </template>
                                <div class="col form-group">
                                    <label class="control-label require" for="rate_type">Rate Type</label>
                                    <v-select v-model="rate_type" name="rate_type" placeholder="Select Rate Type."
                                                label="text"
                                                :options="rateTypesArr">
                                    </v-select>
                                    <div class="field-error">{{rate_type_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="name">Value:</label>
                                    <input type="text" class="form-control" @input="validateInput($event)"
                                    @keypress="isNumberCheck($event)" v-model="rate" id="rate" placeholder="Enter Value" name="rate" max="999999.99">
                                    <div class="field-error">{{rate_error_msg}}</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                </div>
                            </div>
                            <div class="btn-groups mb-5">
                                <button v-if="updatePriceBookFlag" :disabled='isDisableStore' type="submit" id="createPriceBookBtn" class="btn btn-primary" v-on:click.prevent="addPriceBook('update')">
                                    <i class="fp-reload"> </i>  Update
                                </button>
                                <button v-if="!updatePriceBookFlag" :disabled='isDisableStore' type="submit" id="createPriceBookBtn" class="btn btn-primary" v-on:click.prevent="addPriceBook('add')">
                                    <i class="fp-save"> </i>  Save
                                </button>

                                <button v-if="!updatePriceBookFlag" type="submit" id="createAndContinuePriceBookBtn" class="btn btn-tertiary" v-on:click.prevent="addPriceBook(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                </button>
                                <button id="cancelPriceBookBtn" class="btn btn-tertiary" v-on:click.prevent="cancelPriceBook()">
                                    <i class="fp-remove"> </i> Cancel
                                </button>
                            </div>
                        </form>
                    </section>
                </div>
                <div class="admin-page-content def-price-book" v-show="!addPriceBookFlag">
                    <data-table-filter-config :moduleName="'defPriceBook'" ref='defaultPriceBook' @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                    <div class="data-table bg-white overflow-hidden">
                        <section class="data-table bg-white">
                            <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'defPriceBook'" :position="'top'">
                            </custom-pagination>
                            <vue-good-table
                                    ref="defPriceBook"
                                    mode="remote"
                                    title="Price Book"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    @on-selected-rows-change="selectionChanged"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                        enabled: false,
                                    }">
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action' && props.row.expiry_date == '-'">
                                                <a title="Edit Price Book" href="javascript:void(0)" class="fp-edit" v-on:click="updatePriceBook(props.row.id)"></a>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <button v-if="canRemovePriceBook" id="removePriceBookBtn" v-on:click.prevent="removePriceBook" class="btn btn-danger">Delete</button>
                                    </div>
                            </vue-good-table>
                            <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>
                    </div>
                </div>
            </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
             <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';


import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {
    name: "CustomerPriceBook",
    metaInfo() {
        return {title: "PriceBook List | " +process.env.COPYRIGHT_NAME}
    },
    mixins:[commonMixins,contractMixins,dataTableMixins],
    data: () => ({
        isDisableStore: false,
        permissions: [],
        disableCustomer:false,
        cantAccessPage: "",
        addPriceBookFlag:false,
        updatePriceBookFlag:false,
        rows:[],
        idArr:[],
        price_book_id:0,
        is_miscellaneous:false,
        effective_date:"",
        expiry_date:"",
        cost_type:"",
        rate_type:"",
        charge_id:"",
        rate:"",
        rateEdit:true,
        costTypesArr:[],
        rateTypesArr:[],
        chargesArr:[],
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
            showClose: true,
        },
        showChargeField:false,
        effective_date_error_msg:"",
        charge_type_error_msg:"",
        cost_type_error_msg:"",
        rate_type_error_msg:"",
        rate_error_msg:"",
        location_error_msg:"",
        customer_class_error_msg:"",
        firstLoad : 0,
        rTypeArr:[],
        disableFields:false,
        canRemovePriceBook:false,
        customer_class:"",
        customerClassArr:[],
        disableCustomerClass:false,
        location_id:"",
        locationArr:[],
        disableLocation:false,
        userColumns:[],
        customer_id: null,
        customerArr: [],
        customer_error_msg: "",
        showCustomerField:false,
        showCustomerClassField:false,
        showLocationField:false,
        disablePriceType:false,
        columns:[
            {
                label: 'Actions',
                field: 'action',
                html: true,
                sortable: false,

            },
            {
                label:'Price Type',
                field:'cp_price_type',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    filterDropdownItems: ['Customer','Customer Class','Location'],
                },
            },
            {
                label:'Customer',
                field:'customer',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Customer Class',
                field:'customer_class',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Location',
                field:'location',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                label:'Effective Date',
                field:'effective_date',
                fpFieldType:"date",
                filterable: false,
                hidden:false,
            },
            {
                label:'Expiry Date',
                field:'expiry_date',
                fpFieldType:"date",
                filterable: false,
                hidden:false,
            },
            
            {
                label:'Charge Code',
                field:'charge_code',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Cost Type',
                field:'cost_type',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                label:'Rate Type',
                field:'rate_type',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                label: "Rate",
                field: "rate",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
        ],
        totalRecords: 0,
        loading:false,
        action:'list',
        canAddPriceBook:false,
        priceTypeArr:[
                        {
                            text:"Customer",
                            value:"customer"
                        },
                        {
                            text:"Customer Class",
                            value:"customer_class"
                        },
                        {
                            text:"Location",
                            value:"location"
                        },
        ],
        priceType:"",
        price_book_type:"",
    }),
    watch: {

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_price_book') {

                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'add_price_book') {

                        self.canAddPriceBook = true;
                    }
                    if (permissions[i].name == 'delete_price_book') {
                        self.canRemovePriceBook = true;
                    }
                }
            }

        },
        charge_id: function(){

            var self = this;

            self.rateTypesArr = [];
            self.rateTypesArr.push({text:'Fixed (F)',value:'F'});
        },

        cost_type: function(val,oldVal){
            var self = this;

            if ( val === null ) {
                return;
            }

            if ( self.rTypeArr.length > 0){
                self.rateTypesArr = JSON.parse(JSON.stringify(self.rTypeArr));
            }

            if (self.firstLoad == 0){
                self.rTypeArr = JSON.parse(JSON.stringify(self.rateTypesArr));

            }
            console.log(self.rTypeArr);
            
            if ( oldVal && oldVal.value != undefined){
                self.rate_type = '';
            }
            
            self.firstLoad = 1;
            if ( val.value == 'M') {
                
                self.rateTypesArr = [];
                self.rateTypesArr.push({text:'% of Parts (A)',value:'A'});
                self.rateTypesArr.push({text:'Margin (G)',value:'G'});
                self.rateTypesArr.push({text:'Markup (M)',value:'M'});

            } else if ( val.value == 'L') {

                self.rateTypesArr = [];
                self.rateTypesArr.push({text:'per Hour (H)',value:'H'});
                self.rateTypesArr.push({text:'Margin (G)',value:'G'});
                self.rateTypesArr.push({text:'Markup (M)',value:'M'});

            } else if ( val.value == 'E') {

                self.rateTypesArr = [];
                self.rateTypesArr.push({text:'Fixed (F)',value:'F'});
                self.rateTypesArr.push({text:'Flow Through (O)',value:'O'});

            } else if ( val.value == 'S') { 

                self.rateTypesArr = [];
                self.rateTypesArr.push({text:'% of Labor (L)',value:'L'});

            } else if ( val.value == 'X') {

                self.rateTypesArr = [];
                self.rateTypesArr.push({text:'per Hour (H)',value:'H'});
                self.rateTypesArr.push({text:'Margin (G)',value:'G'});
                self.rateTypesArr.push({text:'Markup (M)',value:'M'});

            } else if ( val.value == 'Y'){

                self.rateTypesArr = [];
                self.rateTypesArr.push({text:'Margin (G)',value:'G'},{text:'Markup (M)',value:'M'},{text:'% of Parts (A)',value:'A'});

            }
        }
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        self.getPermissions();
        // if (segments[3]) {
            // self.loadList();
        // }
        self.loadFieldData(['cost_types','rate_types','customer_charges','customerClass','location']);
    },
    methods: {
        validateInput(evt) {
          var self = this;
          evt = (evt) ? evt : window.event;
          if(evt.target.value > 999999.99) {
            self.rateEdit = false;
            self.rate_error_msg = "Amount value exceed";
            self.isDisableStore = true;
          } else {
            self.rateEdit = true;
            self.rate_error_msg = "";
            self.isDisableStore = false;
          }

        },

        isNumberCheck: function(evt) {
            var self = this;
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
                evt.preventDefault();
            } else {
                if(self.rateEdit) {
                  return true;
                } else {
                  evt.preventDefault();
                }
                return true;
            }
        },
        onChargeSelect(event) {
            var self = this;
            if (self.charge_id != null && self.charge_id != "") {
                self.rate = self.charge_id.rate;
            }else{
                self.rate = "";
            }
            self.rate_type = '';
            self.rateTypesArr = [];
            self.rateTypesArr.push({text:'Fixed (F)',value:'F'});
        },
        saveId(evt,id){
            var self = this;
            // alert(id);
            console.log(evt.target.checked);
            if(evt.target.checked == true){
                self.idArr.push({id:id});
            }else{
                var i = self.idArr.indexOf(id);
                const filteredItems = self.idArr.filter(function(item) {
                    return item.id !== id
                })
                self.idArr = filteredItems;
            }
            console.log(self.idArr);
        },
        isMiscellaneous(event){
            var self = this;
            if(event.target.checked) {

                self.rateTypesArr = [];

                self.rateTypesArr.push({text:'Fixed (F)',value:'F'});

                self.showChargeField = true;
                for (var i = 0; i < self.chargesArr.length; i++){

                    if ( self.chargesArr[i].identifier == 'labor'){
                        delete self.chargesArr[i];
                        self.chargesArr.splice(i, 1);
                    }
                    if ( self.chargesArr[i].identifier == 'part'){
                        delete self.chargesArr[i];
                        self.chargesArr.splice(i, 1);
                    }
                    if ( self.chargesArr[i].identifier == 'sublet_labor'){
                        delete self.chargesArr[i];
                        self.chargesArr.splice(i, 1);
                    }
                    if ( self.chargesArr[i].identifier == 'sublet_part'){
                        delete self.chargesArr[i];
                        self.chargesArr.splice(i, 1);
                    }

                }
                self.is_miscellaneous = true;

                if (self.price_book_id > 0) {
                    self.cost_type = "";
                    self.cost_type_error_msg = "";
                    self.charge_id = "";
                    self.charge_type_error_msg = "";
                    self.customer_class = "";
                    self.location_id = "";
                }else{
                    self.effective_date = "";
                    self.expiry_date = "";
                    self.cost_type = "";
                    self.rate_type = "";
                    self.rate = "";
                    self.charge_id = "";
                    self.effective_date_error_msg = "";
                    self.cost_type_error_msg = "";
                    self.rate_type_error_msg = "";
                    self.rate_error_msg = "";
                    self.charge_type_error_msg = "";
                    self.customer_class = "";
                    self.location_id = "";
                }


            }else{

                self.loadFieldData(['rate_types']);

                self.showChargeField = false;
                self.is_miscellaneous = false;

                if (self.price_book_id > 0) {
                    self.cost_type = "";
                    self.cost_type_error_msg = "";
                    self.charge_id = "";
                    self.charge_type_error_msg = "";
                    self.rate = "";
                    self.customer_class = "";
                    self.location_id = "";
                }else{
                    self.effective_date = "";
                    self.expiry_date = "";
                    self.charge_id = "";
                    self.cost_type = "";
                    self.rate_type = "";
                    self.rate = "";
                    self.effective_date_error_msg = "";
                    self.charge_type_error_msg = "";
                    self.cost_type_error_msg = "";
                    self.rate_type_error_msg = "";
                    self.rate_error_msg = "";
                    self.customer_class = "";
                    self.location_id = "";
                }

            }
        },
        addNewPriceBook() {
            var self = this;
            self.priceType = null;
            self.price_book_id = 0;
            self.addPriceBookFlag = true;
            self.updatePriceBookFlag = false;
            self.showChargeField = false;
            self.is_miscellaneous = false;
            self.effective_date = "";
            self.expiry_date = "";
            self.charge_id = null;
            self.cost_type = null;
            self.rate_type = null;
            self.rate = "";
            self.effective_date_error_msg = "";
            self.charge_type_error_msg = "";
            self.cost_type_error_msg = "";
            self.rate_type_error_msg = "";
            self.rate_error_msg = "";
            self.disableFields = false;
            self.idArr = [];
            self.customer_class = "";
            self.disableCustomerClass = false;
            self.disableCustomer = false;
            self.disableLocation = false;
            self.disablePriceType = false;
            self.customer_id = null;
            self.location_id = null;
            
        },
        addPriceBook(flag){
            var self = this;
            var error = false;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.effective_date_error_msg = "";
            self.charge_type_error_msg = "";
            self.cost_type_error_msg = "";
            self.rate_type_error_msg = "";
            self.rate_error_msg = "";

            if (self.showChargeField) {

                if ( self.charge_id == '' || self.charge_id == null || !self.charge_id.value ) {
                    self.charge_type_error_msg = "Charge Required";
                    error = true;
                }

            }else{

                if ( self.cost_type == '' || self.cost_type == null  || !self.cost_type.value ) {
                    self.cost_type_error_msg = "Cost Type Required";
                    error = true;
                }
            }

            if ( !self.effective_date || self.effective_date == null || self.effective_date == "" ) {
                self.effective_date_error_msg = "Effective Date Required";
                error = true;
            }

            if ( self.rate_type == '' || self.rate_type == null  || !self.rate_type.value ) {
                self.rate_type_error_msg = "Rate Type Required";
                error = true;
            }

            if (!self.rate || self.rate == '') {
                self.rate_error_msg = 'Value Required';
                error = true;
            }

            if (self.rate_type != '' && self.rate_type != null && self.rate_type.value) {

                if (self.rate_type.value == "A" || self.rate_type.value == "M" || self.rate_type.value == "G" || self.rate_type.value == "L") {
                    if (self.rate && self.rate >= 100) {
                        if (self.rate > 100) {
                            self.rate_error_msg = "Value cannot be greater than 100";
                        }else{
                            self.rate_error_msg = "Value cannot be equal to 100";
                        }
                        error = true;
                    }
                }   
            }

            if (self.cost_type.value && self.cost_type.value == 'M'){

                if( self.rate_type.value && self.rate_type.value == 'H' ){

                    self.rate_type_error_msg = 'Please select valid rate type against cost type';
                    error = true;
                }
            }
            // //select customer class or location
            // if (self.customer_class != null && self.location_id != null){
            //     if (self.customer_class.value && self.location_id.value) {
            //         self.$swal('','Either select Customer Class or Location','info');
            //         error = true;
            //     }
            // }

            if ( self.priceType == 'customer' && ( self.customer_id == null || !self.customer_id.value ) ) {
                    self.customer_error_msg = "Customer is require.";
                    error = true;
            }

            if ( self.priceType == 'location' && ( self.location_id == null || !self.location_id.value) ) {
                self.location_error_msg = "Location is require.";
                error = true;
            }

            if ( self.priceType == 'customer_class' && ( self.customer_class == null || !self.customer_class.value) ) {
                self.customer_class_error_msg = "Customer Class is require.";
                error = true;
            }

            if (!error) {

                var fields = $("#PriceBookForm").serializeArray();

                fields.push({
                    name: "customer_id",
                    value: self.customer_id
                });

                fields.push({
                    name: "id",
                    value: self.price_book_id
                });

                if(self.is_miscellaneous == true){
                    fields.push({
                        name: "is_miscellaneous",
                        value: 1
                    });
                }else{
                    fields.push({
                        name: "is_miscellaneous",
                        value: 0
                    });
                }

                if(self.showChargeField){
                    fields.push({
                        name: "charge_id",
                        value: self.charge_id.value
                    });
                }else{
                    fields.push({
                        name: "cost_type",
                        value: self.cost_type.value
                    });
                    fields.push({
                        name: "customer_class",
                        value: ""
                    });
                }
                //customer class if added
                if (self.customer_class != null && self.customer_class != "") {
                    if (self.customer_class.value) {
                        fields.push({
                            name: "customer_class",
                            value: self.customer_class.value
                        });
                    }else{
                        fields.push({
                            name: "customer_class",
                            value: ""
                        });
                    }
                }else{
                    fields.push({
                        name: "customer_class",
                        value: ""
                    });
                }
                if (self.location_id != null && self.location_id != "") {
                    if (self.location_id.value) {
                        fields.push({
                            name: "location_id",
                            value: self.location_id.value
                        });
                    }else{
                        fields.push({
                            name: "location_id",
                            value: ""
                        });
                    }
                }else{
                    fields.push({
                        name: "location_id",
                        value: ""
                    });
                }

                if (self.customer_id != null && self.customer_id != "") {
                    if (self.customer_id.value) {
                        fields.push({
                            name: "customer_id",
                            value: self.customer_id.value
                        });
                    }else{
                        fields.push({
                            name: "customer_id",
                            value: null
                        });
                    }
                }else{
                    fields.push({
                        name: "customer_id",
                        value: ""
                    });
                }

                fields.push({
                    name: "rate_type",
                    value: self.rate_type.value
                });

                fields.push({
                    name: "price_type",
                    value: self.priceType.value
                });

                self.loading = true;

                if (self.price_book_id > 0)
                {
                    $("#createPriceBookBtn").val("Updating ...");
                    $("#createPriceBookBtn").prop("disabled", true);
                    $("#cancelPriceBookBtn").prop("disabled",true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinuePriceBookBtn").val("Saving ...");
                        $("#createPriceBookBtn").prop("disabled", true);
                        $("#createAndContinuePriceBookBtn").prop("disabled", true);
                        $("#cancelPriceBookBtn").prop("disabled",true);

                    }else{

                        $("#createPriceBookBtn").val("Saving ...");
                        $("#createPriceBookBtn").prop("disabled", true);
                        $("#createAndContinuePriceBookBtn").prop("disabled", true);
                        $("#cancelPriceBookBtn").prop("disabled",true);
                    }

                }

                $.ajax({
                    url: process.env.ROOT_API + "/customer/price-book/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (flag == "Save and Continue") {

                            $("#createAndContinuePriceBookBtn").val("Save and Continue");
                            $("#createPriceBookBtn").prop("disabled", false);
                            $("#createAndContinuePriceBookBtn").prop("disabled", false);
                            $("#cancelPriceBookBtn").prop("disabled",false);

                        } else {

                            $("#createPriceBookBtn").val("Save");
                            $("#createPriceBookBtn").prop("disabled", false);
                            $("#createAndContinuePriceBookBtn").prop("disabled", false);
                            $("#cancelPriceBookBtn").prop("disabled",false);

                        }

                        if (data.code == 200) {

                            if (flag == "Save and Continue") {
                                self.price_book_id = 0;
                                self.effective_date = "";
                                self.expiry_date = "";
                                self.is_miscellaneous = false;
                                self.showChargeField = false;
                                self.cost_type = "";
                                self.rate_type = "";
                                self.charge_id = "";
                                self.rate = "";
                                self.customer_class = "";
                                self.location_id = "";
                                self.customer_id = null;


                            } else {
                                self.addPriceBookFlag = false;
                                self.loadList();
                            }

                        }

                        if ( data.code == 201){

                            self.$swal('',data.message,'info');
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (self.price_book_id > 0)
                        {
                            $("#createPriceBookBtn").val("Update");
                            $("#createPriceBookBtn").prop("disabled", false);
                            $("#cancelPriceBookBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#createAndContinuePriceBookBtn").val("Save and Continue");
                                $("#createPriceBookBtn").prop("disabled", false);
                                $("#createAndContinuePriceBookBtn").prop("disabled", false);
                                $("#cancelPriceBookBtn").prop("disabled",false);

                            }else{

                                $("#createPriceBookBtn").val("Save");
                                $("#createPriceBookBtn").prop("disabled", false);
                                $("#createAndContinuePriceBookBtn").prop("disabled", false);
                                $("#cancelPriceBookBtn").prop("disabled",false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,true,'price-book-create')
                    }
                });

            }else{
                self.errorValidationFocus();
            }

        },
        loadList() {
            var self = this;
            var data = this.$refs['defPriceBook'].selectedRows;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(data[i].id)
            }
            self.loading = true;
            var fields = {
                customer_id:0,
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action: self.action,
                all:self.serverParams.selectedAll,
                selectedRows:use,
            };
            $.ajax({
                url: process.env.ROOT_API + "/customer/price-book/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        if (self.action == "delete") {
                            self.action = "list";
                            var msg = "";

                            msg = data.content+" records have been deleted";

                            self.$swal('',msg,data.status);
                            self.$refs.defaultPriceBook.clearSelectAll();
                            self.loadList();
                            return;
                        }else{
                            self.rows = data.content.rows;
                            self.totalRecords = data.content.totalRecords;
                            self.addPriceBookFlag = false;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'price-book-list')
                }
            });
        },
        updatePriceBook(priceBookId) {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/customer/price-book/" + priceBookId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.price_book_id = data.content.id;
                        self.disablePriceType = true;
                        self.effective_date = data.content.effective_date;
                        self.expiry_date = data.content.expiry_date;
                        self.rate = data.content.rate;
                        self.priceType = {
                                text: data.content.price_type_name,
                                value: data.content.price_type
                        }
                        if (data.content.customer_class_id != undefined && data.content.customer_class_id != null) {
                            self.customer_class = {
                                text:data.content.cc_code,
                                value:data.content.customer_class_id
                            }
                            self.disableCustomerClass = true;
                        }else{
                            self.disableCustomerClass = false;
                            self.customer_class = "";
                        }
                        if (data.content.customer_id != undefined && data.content.customer_id != null) {
                            self.customer_id = {
                                text:data.content.customer_name,
                                value:data.content.customer_id
                            }
                            self.disableCustomer = true;
                        }else{
                            self.showCustomerField = false;
                            self.disableCustomer = false;
                            self.customer_id = null;
                        }
                        if (data.content.location_id != undefined && data.content.location_id != null) {
                            self.location_id = {
                                text:data.content.loc_code + " | " + data.content.company_name,
                                value:data.content.location_id
                            }
                            self.disableLocation = true;
                        }else{
                            self.disableLocation = false;
                            self.location_id = "";
                        }
                        if (data.content.is_miscellaneous == 1) {
                            $("#is_miscellaneous").prop("checked",true);
                            self.is_miscellaneous = true;
                            self.showChargeField = true;
                            self.charge_id = {
                                text:self.ucString(data.content.charge_name),
                                value:data.content.charge_id
                            }

                        } else {

                            $("#is_miscellaneous").prop("checked",false);
                            self.is_miscellaneous = false;
                            self.showChargeField = false;
                            self.cost_type = {
                                text:data.content.cost_type_name + " (" + data.content.cost_type + ")",
                                value:data.content.cost_type
                            }
                        }

                        setTimeout(function () {
                            self.rate_type = {
                                text:data.content.rate_type_name + " (" + data.content.rate_type + ")",
                                value:data.content.rate_type
                            }
                        }, 100);
                        self.addPriceBookFlag = true;
                        self.updatePriceBookFlag = true;
                        self.disableFields = true;
                        self.effective_date_error_msg = "";
                        self.charge_type_error_msg = "";
                        self.cost_type_error_msg = "";
                        self.rate_type_error_msg = "";
                        self.rate_error_msg = "";
                        self.idArr = [];
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'price-book-by-id')
                }
            });

        },
        removePriceBook(){
            var self = this;
            self.$swal({
                title: 'Are you sure that you want to delete this Price Book?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    self.action = "delete";
                    self.loadList();

                } else {

                }
            });
        },
        cancelAll: function (cancelAll) {
          this.$refs.defPriceBook.unselectAllInternal();
        },
        cancelPriceBook() {
            var self = this;
            self.$set(self.serverParams, 'columnFilters', []);
            self.$refs.defaultPriceBook.priceBookLoad();
            self.loadList();
        },
        onSelectCustomer: function (evt) {
          var self = this;
          var path = window.location.pathname;
          var segments = path.split("/");
          if (!segments[3]) {
            if (self.customer_id.user_location && self.customer_id.user_location != '') {
              self.location_id = self.customer_id.user_location;
            } else if (self.customer_id.location && self.customer_id.location != '') {
              self.location_id = self.customer_id.location;
            }
          }
        },
        titleCase(str) {
        if (str == null){
          return;
        } else{
          var value = str.toString()
          return value.charAt(0).toUpperCase() + value.slice(1)
        }
      },
        onSearchCustomer(search, loading) {
          var self = this;
          if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
          }
        },
        onChangeType(search) {
            var self = this;

            if ( search == null ) {
                return;
            }
          
            if (search.value === 'customer_class') {
                self.showCustomerField = false
                self.showLocationField = false
                self.showCustomerClassField = true
            }

            if (search.value === 'customer') {
                self.showCustomerField = true
                self.showLocationField = false
                self.showCustomerClassField = false
            }

            if (search.value === 'location') {
                self.showCustomerField = false
                self.showLocationField = true
                self.showCustomerClassField = false
            }
        },
    },
    onSearchCustomer(search, loading) {
      var self = this;
      if (search.length > 2) {

        loading(true);
        self.searchField(loading, search, 'customer', '');
      }
    },
}
</script>





// WEBPACK FOOTER //
// src/components/customer/DefaultPriceBook.vue